module.exports = __webpack_public_path__ + "static/media/light-05.77cbdcde.jpg";